import { Icon } from '@/shared/types/icon';

export const CartesiaIcon = ({ size = 16, className = '' }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 16 16"
    className={className}
  >
    <path
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      d="M10.5 3.7A5 5 0 1 0 10.5 12.3"
    />
  </svg>
);
